import { useDeleteUserMutation } from '@features/redux/apis/auth';
import { useAlert } from '@hooks/useAlert';
import { MutationEffect } from '@helpers/MutationEffect';

export const UserActionsEffects = () => {
    const { setAlert } = useAlert();

    const [, mutationState] = useDeleteUserMutation({
        fixedCacheKey: 'DeleteUser',
    });

    return (
        <MutationEffect
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            mutationState={mutationState}
            effects={{
                isError: () => {
                    setAlert('Failed to delete user.', 'error');
                    mutationState.reset();
                },
                isSuccess: () => {
                    setAlert('Successfully deleted user.', 'success');
                    mutationState.reset();
                },
            }}
        />
    );
};
